export enum ItemStatus {
  LOADING = 'LOADING',
  OK = 'OK',
  ERROR = 'ERROR',
  IDLE = 'IDLE'
}

export enum PackageType {
  HALFBOX = 'HALF BOX',
  BOX = 'BOX',
  UNIT = 'UNIT'
}
